module.exports = __webpack_public_path__ + "static/media/exela_onDark_logo.85fbe15e.png";